import { combineReducers } from 'redux';

import reviewsForListing from 'app/shared/reducers/reviews/reviewsForListing';

const rootReviewsReducer = combineReducers({
    reviewsForListing,
});

export default rootReviewsReducer;
